export const COMPONENT_BASE = 'ContractItemRecord';
export const COMPONENT_MAIN = `${COMPONENT_BASE}Main`;
export const COMPONENT_LIST = `${COMPONENT_BASE}List`;
export const COMPONENT_DETAIL = `${COMPONENT_BASE}Detail`;

export const TAB_LIST = 'list';
export const OPERATION_LIST_DEFAULT = 'list.default';

export const TAB_DETAIL = 'detail';
export const OPERATION_DETAIL_SHOW = 'detail.show';
export const OPERATION_DETAIL_ADD = 'detail.add';
export const OPERATION_DETAIL_EDIT = 'detail.edit';

export const FN_SET_OPERATION = 'setOperation';
export const FN_SET_TAB = 'setTab';

export const FN_LIST_QUERY = 'query';

export const FN_TO_DETAIL_SHOW = 'toDetailShow';
export const FN_TO_DETAIL_ADD = 'toDetailAdd';
export const FN_TO_DETAIL_EDIT = 'toDetailEdit';

export const ENUM_CONTENT_POWER = 'POWER'; // 用电
export const ENUM_CONTENT_NETWORK = 'NETWORK'; // 宽带
export const ENUM_CONTENT_CONN = 'CONN'; // 连接

export const contentHash = {
    [ENUM_CONTENT_POWER]: '用电计费记录',
    [ENUM_CONTENT_NETWORK]: '宽带计费记录',
    [ENUM_CONTENT_CONN]: '连接计费记录',
} 

export const PERMISSION_ADD = null;
export const PERMISSION_EDIT = null;
export const PERMISSION_DELETE = null;

export const getContentByQuery = (query) => {
    let content = query.content;
    if (content == null || String(content).trim() === '') {
        content = ENUM_CONTENT_POWER;
    }
    if (content !== ENUM_CONTENT_POWER && content !== ENUM_CONTENT_NETWORK && content !== ENUM_CONTENT_CONN) {
        throw `不支持的参数, content: ${content}`;
    }
    return content;
};

export const runByContent = (content, runs) => {
    let run;
    if (ENUM_CONTENT_POWER === content) {
        run = runs[0];
    } else if (ENUM_CONTENT_NETWORK === content) {
        run = runs[1];
    } else if (ENUM_CONTENT_CONN === content) {
        run = runs[2];
    } else {
        throw `不支持的content类型[${ENUM_CONTENT_POWER}, ${ENUM_CONTENT_NETWORK}]`;
    }
    return run();
};
